export const WITH_TOP_FILTER_CATALOG = 'withTopFilterCatalog';
